import Vue from 'vue';
import consentService from '@/modules/consent-service';

const GET_MARKETING_ANSWER = 'GET_MARKETING_ANSWER',
	SET_MARKETING_ANSWER = 'SET_MARKETING_ANSWER',
	GET_MARKETING_SUCCESS = 'GET_MARKETING_SUCCESS';

const state = {
	marketingEnabledAnswer: null,
};

function isGdprCountry(countryCode) {
	const gdprCodeList = [
		'LU',
		'GB',
		'IS',
		'IL',
		'ES',
		'IT',
		'KR',
		'CH',
		'DK',
		'NO',
		'FR',
		'IE',
		'SK',
		'SI',
		'GR',
		'SE',
		'BG',
		'PL',
		'LV',
		'LT',
		'BE',
		'EE',
		'LI',
		'AT',
		'HU',
		'PT',
		'RO',
		'HR',
		'DE',
		'CZ',
		'CY',
		'NL',
		'FI',
		'MT'
	];
	return gdprCodeList.includes(countryCode);
}

const getters = {
	showConsentNotice: (state, getters, rootState, rootGetters) =>  {
		const ip = rootState.user.user && rootState.user.user.ipInfo;
		return ip && isGdprCountry(ip.country_code) && state.marketingEnabledAnswer === 'unknown';
	},
	marketingEnabled: state => state.marketingEnabledAnswer === 'yes'
};

const actions = {

	[SET_MARKETING_ANSWER] ({ commit }, payload){
		commit(SET_MARKETING_ANSWER, payload);
	}

};

const mutations = {
	[SET_MARKETING_ANSWER]: (state, response) => {
		state.marketingEnabledAnswer = response;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/consent.js